module.exports = __webpack_public_path__ + "static/media/cyber-security-navy-blue.fe1fb74b.gif";